import { render, staticRenderFns } from "./Iorder.vue?vue&type=template&id=0df508a2&"
import script from "./Iorder.vue?vue&type=script&lang=js&"
export * from "./Iorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports